
// FILE: src/controller/RadioController.js
function RadioController() {

    this.setOption = function (field, option) {
        field.setValue(option);
    };
}

Configuration(function (ContextRegister) {
    ContextRegister.register('RadioController', RadioController);
});